import { useStore } from "../../../store/store";
import { CalendarFiltersType } from "../calendar.types";
import { CalendarView } from "../../../store/store.types";
import { useScheduleOverlay } from "./useScheduleOverlay";

const INCOMPATIBLE_OVERLAY_VIEWS: Array<CalendarView> = ["month", "agenda", "year"];

type UseSessionsOverlayPropsArgs = {
    calendarFilters: CalendarFiltersType | null;
    defaultView: CalendarView;
};

const isCompatibleView = (view: CalendarView) => {
    const compatible = !INCOMPATIBLE_OVERLAY_VIEWS.includes(view);
    return compatible;
};

export const useSessionsOverlayProps = ({ calendarFilters, defaultView }: UseSessionsOverlayPropsArgs) => {
    const {
        calendar: {
            calendarView,
            scheduleOverlayEnabled,
            scheduleOverlayShowTimeOff,
            scheduleOverlayDiscountBreaks,
            scheduleOverlayShowBackoffice,
        },
    } = useStore();

    const currentView = calendarView || defaultView;
    const overlayEnabled = scheduleOverlayEnabled && isCompatibleView(currentView);

    const { overlayEvents } = useScheduleOverlay({
        filters: calendarFilters,
        enabled: overlayEnabled,
        showTimeOff: scheduleOverlayShowTimeOff,
        showBackoffice: scheduleOverlayShowBackoffice,
    });

    const overlayProps = {
        backgroundEvents: overlayEvents,
        showBackgroundEvents: overlayEnabled,
        discountBreaks: scheduleOverlayDiscountBreaks,
    };
    return overlayProps;
};
